/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiFieldTranslationNotificationPayloadAiGenerationsInner } from './AiFieldTranslationNotificationPayloadAiGenerationsInner';
import {
    AiFieldTranslationNotificationPayloadAiGenerationsInnerFromJSON,
    AiFieldTranslationNotificationPayloadAiGenerationsInnerFromJSONTyped,
    AiFieldTranslationNotificationPayloadAiGenerationsInnerToJSON,
    AiFieldTranslationNotificationPayloadAiGenerationsInnerToJSONTyped,
} from './AiFieldTranslationNotificationPayloadAiGenerationsInner';

/**
 * A creation, update or deletion of AI field translations of the company.
 * @export
 * @interface AiFieldTranslationNotificationPayload
 */
export interface AiFieldTranslationNotificationPayload {
    /**
     * What happened to the AI field translations.
     * @type {AiFieldTranslationNotificationPayloadOperationEnum}
     * @memberof AiFieldTranslationNotificationPayload
     */
    operation: AiFieldTranslationNotificationPayloadOperationEnum;
    /**
     * The AI field translations that were created, updated or deleted.
     * @type {Array<AiFieldTranslationNotificationPayloadAiGenerationsInner>}
     * @memberof AiFieldTranslationNotificationPayload
     */
    aiGenerations: Array<AiFieldTranslationNotificationPayloadAiGenerationsInner>;
}


/**
 * @export
 */
export const AiFieldTranslationNotificationPayloadOperationEnum = {
    Creation: 'creation',
    Update: 'update',
    Deletion: 'deletion'
} as const;
export type AiFieldTranslationNotificationPayloadOperationEnum = typeof AiFieldTranslationNotificationPayloadOperationEnum[keyof typeof AiFieldTranslationNotificationPayloadOperationEnum];


/**
 * Check if a given object implements the AiFieldTranslationNotificationPayload interface.
 */
export function instanceOfAiFieldTranslationNotificationPayload(value: object): value is AiFieldTranslationNotificationPayload {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('aiGenerations' in value) || value['aiGenerations'] === undefined) return false;
    return true;
}

export function AiFieldTranslationNotificationPayloadFromJSON(json: any): AiFieldTranslationNotificationPayload {
    return AiFieldTranslationNotificationPayloadFromJSONTyped(json, false);
}

export function AiFieldTranslationNotificationPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiFieldTranslationNotificationPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'operation': json['operation'],
        'aiGenerations': ((json['aiGenerations'] as Array<any>).map(AiFieldTranslationNotificationPayloadAiGenerationsInnerFromJSON)),
    };
}

export function AiFieldTranslationNotificationPayloadToJSON(json: any): AiFieldTranslationNotificationPayload {
    return AiFieldTranslationNotificationPayloadToJSONTyped(json, false);
}

export function AiFieldTranslationNotificationPayloadToJSONTyped(value?: AiFieldTranslationNotificationPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation': value['operation'],
        'aiGenerations': ((value['aiGenerations'] as Array<any>).map(AiFieldTranslationNotificationPayloadAiGenerationsInnerToJSON)),
    };
}

